import Main from './subPages/main';

const routes = [
  {
    path: '/mistery_reports/*',
    canUse: [],
    Component: Main,
  },
];

export default routes;
